module.exports = __webpack_public_path__ + "static/media/marker-black.4099aaaa.svg";